/**
 * Formats API error detail objects (especially Pydantic/FastAPI validation errors)
 * into a human-readable string.
 */
export const formatApiError = (detail: any): string => {
    if (!detail) return 'Something went wrong. Please try again.';

    if (typeof detail === 'string') return detail;

    if (Array.isArray(detail)) {
        return detail
            .map((err: any) => {
                if (err.msg && err.loc && Array.isArray(err.loc)) {
                    // loc usually is ["body", "field_name"] or ["body", "sheds", 0, "capacity"]
                    // We take the specific field name
                    const field = err.loc[err.loc.length - 1];
                    
                    // If it's just 'body' or an index, it's not very helpful as a label
                    if (field === 'body' || field === 'query' || field === 'path' || typeof field === 'number') {
                        return err.msg;
                    }
                    
                    const fieldName = String(field)
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (l) => l.toUpperCase());
                    return `${fieldName}: ${err.msg}`;
                }
                if (typeof err === 'string') return err;
                return JSON.stringify(err);
            })
            .join(' | ');
    }

    if (typeof detail === 'object') {
        // Handle common error structures
        const msg = detail.detail || detail.message || detail.error || detail.msg;
        if (msg) return typeof msg === 'string' ? msg : JSON.stringify(msg);
        return JSON.stringify(detail);
    }

    return String(detail);
};
